var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "download-container" }, [
    _c("div", { staticClass: "download-body" }, [
      _c("div", { staticClass: "image-container" }, [
        _c("div", { staticClass: "section" }, [
          _c("img", {
            staticClass: "download-img lazyload",
            attrs: {
              "data-src": require("@/assets/download_bg_tmp.jpg"),
              alt: "download section 1"
            },
            on: { click: _vm.handleDownload }
          })
        ]),
        _vm._v(" "),
        _vm._m(0)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section last-section" }, [
      _c("div", { staticClass: "copyright" }, [
        _vm._v(
          "\n                    Copyright © 2024 深圳市寻讯科技有限公司 版权所有 "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://beian.miit.gov.cn/#/Integrated/index",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v(" 粤ICP备2024291999号")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ea48830", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea48830","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/content/mobile/download_page.vue
// module id = null
// module chunks = 